export enum FindAllPaymentTerminalsSort {
  DESCRIPTION = 'description',
  TERMINAL_ID = 'terminalId',
}
